// 버그 신고 자동 첨부(D5b §4): 버전·빌드·기기/브라우저·화면·장면·최근 오류 5개. 개인정보 없음, 2KB(서버 DIAG_MAX_BYTES) 안.
import { APP_BUILD, APP_VERSION } from '../telemetry/build';
import { browserFamily, osFamily, type RecentError } from '../telemetry/collector';

export const DIAG_BUDGET_BYTES = 1900;

export interface DiagInput {
  scene: string;
  ua: string;
  width: number;
  height: number;
  dpr: number;
  recent: RecentError[];
  /** 렌더러(webgpu·webgl) — 모르면 생략 */
  renderer?: string;
}

/** 진단 평면 객체(값 문자열 ≤512·전체 ≤ DIAG_BUDGET_BYTES). 키는 화면에 그대로 보이므로 한국어 */
export function buildDiagnostics(d: DiagInput): Record<string, string> {
  const out: Record<string, string> = {
    버전: APP_VERSION,
    빌드: APP_BUILD,
    기기: osFamily(d.ua) + ' · ' + browserFamily(d.ua),
    화면: Math.round(d.width) + 'x' + Math.round(d.height) + ' @' + (Math.round(d.dpr * 100) / 100),
    장면: d.scene,
  };
  if (d.renderer) out.렌더러 = d.renderer.slice(0, 32);
  // 최근 오류: "서명 종류 메시지앞부분" 줄(새것 먼저). 크기를 넘으면 오래된 줄부터 뺀다
  const lines = d.recent.slice(0, 5).map((r) => r.sig.slice(0, 8) + ' ' + r.kind + ' ' + r.message.replace(/\s+/g, ' ').slice(0, 70));
  while (lines.length) {
    out.최근오류 = lines.join(' | ').slice(0, 512);
    if (new TextEncoder().encode(JSON.stringify(out)).length <= DIAG_BUDGET_BYTES) break;
    lines.pop();
  }
  if (!lines.length) out.최근오류 = '없음';
  return out;
}
